import { CdpaRequest } from "../../../common/components/cdpaRequest";
import { ViewId } from "../common/formId";
import { ViewModuleMap } from "./viewModuleMap";
const VIEWS_WITH_VIEW_VISIT_METRICS = [
    ViewId.LoginConfirmation,
    ViewId.Login,
    ViewId.RegistrationStart,
    ViewId.RegistrationContinue,
    ViewId.RegistrationSuccess,
    ViewId.IdpRegistrationConfirmLinking,
    ViewId.IdpRegistrationUpdateProfile,
    ViewId.OneTimePassword,
    ViewId.DeviceLoginConfirmation,
    ViewId.DeviceLoginCode,
    ViewId.DeviceLoginSuccess,
    ViewId.DeviceLoginDenied,
    ViewId.Error,
    ViewId.Info
];
export const trySendViewVisitMetrics = () => {
    const viewId = getViewId();
    if (viewId === undefined || shouldSendViewVisitMetrics(viewId) === false) {
        return;
    }
    CdpaRequest.sendViewVisitMetrics(viewId);
};
const shouldSendViewVisitMetrics = (viewId) => VIEWS_WITH_VIEW_VISIT_METRICS.includes(viewId);
export const getVisitId = () => {
    const visitIdKey = "visit_id";
    const visitId = sessionStorage.getItem(visitIdKey);
    if (visitId !== null) {
        return visitId;
    }
    const newVisitId = window.crypto.randomUUID();
    sessionStorage.setItem(visitIdKey, newVisitId);
    return newVisitId;
};
export const getViewId = () => Object.keys(ViewModuleMap).find((viewId) => document.getElementById(viewId) !== null);
export const sendInteractionMetrics = (element, uiType, uiAction) => {
    const uiName = element.dataset.metricsId;
    if (uiName === undefined) {
        console.warn("metricsId for the element is undefined.");
        return;
    }
    const currentViewId = getViewId();
    if (currentViewId === undefined) {
        console.warn("Could not find viewId for the current view.");
        return;
    }
    CdpaRequest.sendUIInteractionMetrics(currentViewId, uiName, uiType, uiAction);
};
